import t from 'react-translate';
import { css } from '@emotion/react';
import React from 'react';
import { novoEdBlack } from 'athena/styles/colors';
import ExpertMentoringGuides from './expert-mentoring-guides';
import ParticipantExperience from './participant-experience';
import { headerLineHeight } from 'styles/global_defaults/fonts';

const styles = css`
  max-width: 820px;
  margin-left: auto;
  margin-right: auto;

  .description {
    color: ${novoEdBlack};
    line-height: ${headerLineHeight}px;
  }
`;

const Guidance = () => {
  const translationBase = t.MENTORING_PROGRAMS.SETTINGS.TABS.GUIDANCE;

  return (
    <div css={styles}>
      <div className='title heading-2 mb-2'>{translationBase.TITLE()}</div>
      <div className='description text-regular mb-6'>
        {translationBase.DESCRIPTION()}
      </div>
      <ExpertMentoringGuides />
      <ParticipantExperience />
    </div>
  );
};

export default Guidance;
